// extracted by mini-css-extract-plugin
export default {"app__container":"App_app__container__BNf5E","app__main":"App_app__main__3iiSw","app__secondary":"App_app__secondary__2fCEj","image":"App_image__m+DX6"};